module.exports = __webpack_public_path__ + "img/up-and-down.13261f56.svg";